module.exports = __webpack_public_path__ + "media/images/bnr-customer-66e9ee5472aeae6742b88c31eac5b672.png";